// tslint:disable
/**
 * respondeco.org
 * API description of respondeco.org
 *
 * The version of the OpenAPI document: 1.2.5
 * Contact: klaus@respondeco.org
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
  import {
    Account,
    AccountFromJSON,
    AccountToJSON,
    ChangePassword,
    ChangePasswordFromJSON,
    ChangePasswordToJSON,
    PasswordRecoveryInitiate,
    PasswordRecoveryInitiateFromJSON,
    PasswordRecoveryInitiateToJSON,
    PasswordRecoveryUpdate,
    PasswordRecoveryUpdateFromJSON,
    PasswordRecoveryUpdateToJSON,
    Registration,
    RegistrationFromJSON,
    RegistrationToJSON,
  } from '../models';

      export interface CheckTokenValidityRequest {
        token: string;
      }

      export interface ConfirmAccountRequest {
        token: string;
      }

      export interface ConfirmPasswordChangeRequest {
        token: string;
      }

      export interface InitiatePasswordChangeRequest {
        changePassword?: ChangePassword;
      }

      export interface InitiatePasswordRecoveryRequest {
        passwordRecoveryInitiate?: PasswordRecoveryInitiate;
      }

      export interface RegisterRequest {
        registration?: Registration;
      }

      export interface UpdatePasswordRequest {
        passwordRecoveryUpdate?: PasswordRecoveryUpdate;
      }


/**
* no description
*/
export interface AccountApi {
    /**
      * Check if the given token is still valid
    */
    checkTokenValidity(requestParameters: CheckTokenValidityRequest): Promise<void>
    /**
      * Confirm the ownership of an account
    */
    confirmAccount(requestParameters: ConfirmAccountRequest): Promise<void>
    /**
      * Confirm the password change
    */
    confirmPasswordChange(requestParameters: ConfirmPasswordChangeRequest): Promise<void>
    /**
      * Delete the currently logged in user
    */
    deleteAccount(): Promise<void>
    /**
      * Initiate the password change of the authenticated user
    */
    initiatePasswordChange(requestParameters: InitiatePasswordChangeRequest): Promise<void>
    /**
      * Initiate a password recovery for the given account (username)
    */
    initiatePasswordRecovery(requestParameters: InitiatePasswordRecoveryRequest): Promise<void>
    /**
      * Register a new user (creates account + organisation)
    */
    register(requestParameters: RegisterRequest): Promise<Account>
    /**
      * Update the password of the account using a token that was generated by the initiation request.
    */
    updatePassword(requestParameters: UpdatePasswordRequest): Promise<void>
}

  /**
  * no description
  */
  export class AccountApiImpl extends runtime.BaseAPI implements AccountApi {

    /**
      * Check if the given token is still valid
    */
    async checkTokenValidityRaw(requestParameters: CheckTokenValidityRequest): Promise<runtime.ApiResponse<void>> {
          if (requestParameters.token === null || requestParameters.token === undefined) {
          throw new runtime.RequiredError('token','Required parameter requestParameters.token was null or undefined when calling checkTokenValidity.');
          }

      const queryParameters: runtime.HTTPQuery = {};

          if (requestParameters.token !== undefined) {
              queryParameters['token'] = requestParameters.token;
          }

      const headerParameters: runtime.HTTPHeaders = {};

      const response = await this.request({
      path: `/account/password-recovery/check-token`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      });

        return new runtime.VoidApiResponse(response);
      }

      /**
        * Check if the given token is still valid
      */
      async checkTokenValidity(requestParameters: CheckTokenValidityRequest): Promise<void> {
        await this.checkTokenValidityRaw(requestParameters);
      }

    /**
      * Confirm the ownership of an account
    */
    async confirmAccountRaw(requestParameters: ConfirmAccountRequest): Promise<runtime.ApiResponse<void>> {
          if (requestParameters.token === null || requestParameters.token === undefined) {
          throw new runtime.RequiredError('token','Required parameter requestParameters.token was null or undefined when calling confirmAccount.');
          }

      const queryParameters: runtime.HTTPQuery = {};

          if (requestParameters.token !== undefined) {
              queryParameters['token'] = requestParameters.token;
          }

      const headerParameters: runtime.HTTPHeaders = {};

      const response = await this.request({
      path: `/account/confirm`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      });

        return new runtime.VoidApiResponse(response);
      }

      /**
        * Confirm the ownership of an account
      */
      async confirmAccount(requestParameters: ConfirmAccountRequest): Promise<void> {
        await this.confirmAccountRaw(requestParameters);
      }

    /**
      * Confirm the password change
    */
    async confirmPasswordChangeRaw(requestParameters: ConfirmPasswordChangeRequest): Promise<runtime.ApiResponse<void>> {
          if (requestParameters.token === null || requestParameters.token === undefined) {
          throw new runtime.RequiredError('token','Required parameter requestParameters.token was null or undefined when calling confirmPasswordChange.');
          }

      const queryParameters: runtime.HTTPQuery = {};

          if (requestParameters.token !== undefined) {
              queryParameters['token'] = requestParameters.token;
          }

      const headerParameters: runtime.HTTPHeaders = {};

      const response = await this.request({
      path: `/account/confirm-password-change`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      });

        return new runtime.VoidApiResponse(response);
      }

      /**
        * Confirm the password change
      */
      async confirmPasswordChange(requestParameters: ConfirmPasswordChangeRequest): Promise<void> {
        await this.confirmPasswordChangeRaw(requestParameters);
      }

    /**
      * Delete the currently logged in user
    */
    async deleteAccountRaw(): Promise<runtime.ApiResponse<void>> {
      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

            if (this.configuration && (this.configuration.accessToken || this.configuration.apiKey)) {
            const token = this.configuration.accessToken || this.configuration.apiKey;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
            headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
            }
      const response = await this.request({
      path: `/account`,
      method: 'DELETE',
      headers: headerParameters,
      query: queryParameters,
      });

        return new runtime.VoidApiResponse(response);
      }

      /**
        * Delete the currently logged in user
      */
      async deleteAccount(): Promise<void> {
        await this.deleteAccountRaw();
      }

    /**
      * Initiate the password change of the authenticated user
    */
    async initiatePasswordChangeRaw(requestParameters: InitiatePasswordChangeRequest): Promise<runtime.ApiResponse<void>> {
      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

          headerParameters['Content-Type'] = 'application/json';

            if (this.configuration && (this.configuration.accessToken || this.configuration.apiKey)) {
            const token = this.configuration.accessToken || this.configuration.apiKey;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
            headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
            }
      const response = await this.request({
      path: `/account/initiate-password-change`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
              body: ChangePasswordToJSON(requestParameters.changePassword),
      });

        return new runtime.VoidApiResponse(response);
      }

      /**
        * Initiate the password change of the authenticated user
      */
      async initiatePasswordChange(requestParameters: InitiatePasswordChangeRequest): Promise<void> {
        await this.initiatePasswordChangeRaw(requestParameters);
      }

    /**
      * Initiate a password recovery for the given account (username)
    */
    async initiatePasswordRecoveryRaw(requestParameters: InitiatePasswordRecoveryRequest): Promise<runtime.ApiResponse<void>> {
      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

          headerParameters['Content-Type'] = 'application/json';

      const response = await this.request({
      path: `/account/password-recovery/initiate`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
              body: PasswordRecoveryInitiateToJSON(requestParameters.passwordRecoveryInitiate),
      });

        return new runtime.VoidApiResponse(response);
      }

      /**
        * Initiate a password recovery for the given account (username)
      */
      async initiatePasswordRecovery(requestParameters: InitiatePasswordRecoveryRequest): Promise<void> {
        await this.initiatePasswordRecoveryRaw(requestParameters);
      }

    /**
      * Register a new user (creates account + organisation)
    */
    async registerRaw(requestParameters: RegisterRequest): Promise<runtime.ApiResponse<Account>> {
      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

          headerParameters['Content-Type'] = 'application/json';

      const response = await this.request({
      path: `/account`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
              body: RegistrationToJSON(requestParameters.registration),
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => AccountFromJSON(jsonValue));
      }

      /**
        * Register a new user (creates account + organisation)
      */
      async register(requestParameters: RegisterRequest): Promise<Account> {
        const response = await this.registerRaw(requestParameters);
        return await response.value();
      }

    /**
      * Update the password of the account using a token that was generated by the initiation request.
    */
    async updatePasswordRaw(requestParameters: UpdatePasswordRequest): Promise<runtime.ApiResponse<void>> {
      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

          headerParameters['Content-Type'] = 'application/json';

      const response = await this.request({
      path: `/account/password-recovery/update`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
              body: PasswordRecoveryUpdateToJSON(requestParameters.passwordRecoveryUpdate),
      });

        return new runtime.VoidApiResponse(response);
      }

      /**
        * Update the password of the account using a token that was generated by the initiation request.
      */
      async updatePassword(requestParameters: UpdatePasswordRequest): Promise<void> {
        await this.updatePasswordRaw(requestParameters);
      }

    }
